module.exports = __webpack_public_path__ + "img/17-01_Acting Decisively.c3cc67e6.svg";